"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adjustLayout = void 0;
var _ = require("lodash");
var extractMarginTop = function (_a) {
    var _b = _a.margin, margin = _b === void 0 ? '0 0 0 0' : _b, marginTop = _a.marginTop;
    return marginTop || margin.match(/([^ ]*) /)[1];
};
var getAdjustment = function (_a) {
    var preAdjustmentLayout = _a.preAdjustmentLayout, adjustingComp = _a.adjustingComp, style = _a.style;
    var height = preAdjustmentLayout.height === adjustingComp.height ? null : adjustingComp.height;
    var topDiff = _.isNumber(adjustingComp.top) && preAdjustmentLayout.top === adjustingComp.top ? null : Math.floor(adjustingComp.top - preAdjustmentLayout.top);
    var marginTop = topDiff ? parseInt(extractMarginTop(style), 10) + topDiff : null;
    return { height: height, marginTop: marginTop };
};
var adjustStyles = function (_a) {
    var _b;
    var stylesMap = _a.stylesMap, adjustmentData = _a.adjustmentData;
    return _.merge({}, stylesMap, (_b = {}, _b[adjustmentData.id] = _(adjustmentData.style).omitBy(_.isNil).mapValues(function (s) { return s + "px"; }).value(), _b));
};
exports.adjustLayout = function (adjustingComp, preAdjustmentLayout, stylesMap) {
    var adjustmentStyle = getAdjustment({
        adjustingComp: adjustingComp,
        preAdjustmentLayout: preAdjustmentLayout,
        style: stylesMap[adjustingComp.id]
    });
    var adjustmentData = { id: adjustingComp.id, style: adjustmentStyle };
    return adjustStyles({ stylesMap: stylesMap, adjustmentData: adjustmentData });
};
//# sourceMappingURL=adjustLayout.js.map